module.exports = __webpack_public_path__ + "static/media/yq.29324991.jpg";